import parse from 'html-react-parser';

// Renders the parts of a Uniformen layout the same way @entur/uniformen's React adapter does. The
// adapter fetches the layout itself, which doesn't fit a React Router loader, so the root loader
// fetches it and these render it. Each renders nothing when Uniformen failed.
export type UniformenMarkup = { headAssets: string; headerHtml: string; scripts: string };

interface UniformenProps {
  uniformen: UniformenMarkup | null;
}

export const UniformenHeadAssets = ({ uniformen }: UniformenProps) => (uniformen ? parse(uniformen.headAssets) : null);

export const UniformenHeader = ({ uniformen }: UniformenProps) => (uniformen ? parse(uniformen.headerHtml) : null);

export const UniformenScripts = ({ uniformen }: UniformenProps) => (uniformen ? parse(uniformen.scripts) : null);
